// extracted by mini-css-extract-plugin
export default {"container":"Board_container__tAnov","line":"Board_line__U+4GR","header":"Board_header__hd8dH"};